"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertTriangleIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var AlertTriangleIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M19.7948 17.5091L12.8414 6.54315C12.3788 5.81212 11.6213 5.82242 11.1587 6.55343L4.20532 17.5042C3.74281 18.2353 4.08844 18.8 4.97348 18.8H19.0259C19.9116 18.8 20.2572 18.2389 19.7947 17.5091L19.7948 17.5091ZM11.9944 8.97027C12.4395 8.97027 12.7845 9.44612 12.7614 10.0278L12.6201 13.5324C12.5976 14.1135 12.3145 14.5893 11.9926 14.5893C11.6701 14.5893 11.3869 14.1135 11.3644 13.5324L11.225 10.0278C11.2025 9.44612 11.5482 8.97027 11.9944 8.97027ZM11.9944 17.2291C11.4326 17.2291 11.0469 16.8319 11.0588 16.2889C11.0588 15.7338 11.445 15.3487 11.9944 15.3487C12.567 15.3487 12.9289 15.7344 12.9414 16.2889C12.9407 16.8319 12.567 17.2291 11.9944 17.2291Z" }))); };
exports.AlertTriangleIcon = AlertTriangleIcon;
